export const remplacementElevageData = [
  {
    title: "Élevage de 1 à 9 chiens - chats",
    subtitle: "105€ HT (126€ TTC)*",
    image: "elevage-1-9.png",
    description: "Tarif journalier pour un élevage de petite taille."
  },
  {
    title: "Élevage de 10 à 19 chiens - chats",
    subtitle: "120€ HT (144€ TTC)*",
    image: "elevage-10-19.png",
    description: "Tarif journalier pour un élevage de taille moyenne."
  },
  {
    title: "Élevage de 20 à 29 chiens - chats",
    subtitle: "140€ HT (168€ TTC)*",
    image: "elevage-20-29.png",
    description: "Tarif journalier pour un élevage plus conséquent."
  },
  {
    title: "Élevage de 30 à 39 chiens - chats",
    subtitle: "160€ HT (192€ TTC)*",
    image: "elevage-30-39.png",
    description: "Tarif journalier pour un grand élevage."
  },
  {
    title: "Élevage de 40 chiens - chats et plus",
    subtitle: "210€ HT (252€ TTC)**",
    image: "elevage-40-49.png",
    description: "Tarif journalier pour les très grands élevages."
  },
  {
    title: "Mise bas",
    subtitle: "120€/mise bas (144€ TTC)",
    image: "mise-bas.png",
    description: "Assistance et suivi lors de la mise bas."
  },
  {
    title: "Portées",
    subtitle: "Sur devis",
    image: "portees.png",
    description: "Tarification personnalisée selon les besoins."
  }
];